
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

// Mock folder type for now
interface ActionFolder {
  id: string;
  name: string;
  parentId: string | null;
  createdAt: string;
  updatedAt: string;
}

// Async thunk for fetching action folders
export const fetchActionFolders = createAsyncThunk(
  'actionFolder/fetchActionFolders',
  async () => {
    // For now, return mock data. In a real app, this would be an API call
    return [
      {
        id: 'all',
        name: 'All Actions',
        parentId: null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      }
    ];
  }
);

interface ActionFolderState {
  folders: ActionFolder[];
  currentFolderId: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: ActionFolderState = {
  folders: [
    {
      id: 'all',
      name: 'All Actions',
      parentId: null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
  ],
  currentFolderId: null,
  loading: false,
  error: null,
};

const actionFolderSlice = createSlice({
  name: 'actionFolder',
  initialState,
  reducers: {
    setCurrentActionFolderId: (state, action: PayloadAction<string | null>) => {
      state.currentFolderId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActionFolders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActionFolders.fulfilled, (state, action) => {
        state.loading = false;
        state.folders = action.payload;
      })
      .addCase(fetchActionFolders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch action folders';
      });
  },
});

export const { setCurrentActionFolderId } = actionFolderSlice.actions;

export const selectCurrentActionFolderId = (state: { actionFolder: ActionFolderState }) => 
  state.actionFolder.currentFolderId;

export default actionFolderSlice.reducer;
